@if (visible()) {
<div class="sofia">
  @if (panelOpen()) {
  <div class="sofia__prompt" role="dialog" aria-labelledby="sofia-title">
    <button type="button" class="sofia__close" aria-label="Cerrar" (click)="dismiss()">
      <lucide-angular name="x" [size]="18" [strokeWidth]="2"></lucide-angular>
    </button>
    @if (consent.accepted()) {
    <p id="sofia-title" class="sofia__title">Permiso de {{ title }}</p>
    <p class="sofia__text">
      {{ title }} tiene tu permiso para conversar contigo en este navegador. Puedes retirarlo
      cuando quieras.
    </p>
    <div class="sofia__actions">
      <mb-button variant="tertiary" size="sm" (click)="dismiss()">Cerrar</mb-button>
      <mb-button variant="primary" size="sm" (click)="revoke()">Retirar permiso</mb-button>
    </div>
    } @else {
    <p id="sofia-title" class="sofia__title">Hola, soy {{ title }}</p>
    <p class="sofia__text">
      Soy una asistente virtual con inteligencia artificial. Para conversar contigo necesito tu
      permiso para procesar lo que me escribas.
      <a routerLink="/policies-privacy" (click)="dismiss()">Política de privacidad</a>
    </p>
    <div class="sofia__actions">
      <mb-button variant="tertiary" size="sm" (click)="dismiss()">Ahora no</mb-button>
      <mb-button variant="primary" size="sm" (click)="activate()">Acepto, conversemos</mb-button>
    </div>
    }
  </div>
  }

  @if (!consent.accepted()) {
  <button
    type="button"
    class="sofia__bubble"
    [style.background-color]="color"
    [attr.aria-label]="'Chatear con ' + title"
    [attr.aria-expanded]="promptOpen()"
    (click)="togglePrompt()"
  >
    <lucide-angular name="message-square" [size]="26" [strokeWidth]="2"></lucide-angular>
  </button>
  }
</div>
}
